import React from "react";
import {FormattedMessage} from "react-intl";
import {EmployeeInReport} from "@/data/entities/employee";
import EmployeeRow from "@widgets/reports/timesheet/chart/EmployeeRow";
import {DayItem} from "@/utils/DateUtils";
import {twJoin} from "tailwind-merge";
import {SetStateFn} from "@/utils/SetStateUtils";

export const titleColClassName = "sticky left-0 z-10 bg-white dark:bg-slate-800 px-4 py-3 border-b border-r border-gray-200 dark:border-slate-700 w-[125px] md:w-[300px] text-left";
export const colClassName = "px-4 py-3 border-gray-200 dark:border-slate-700 text-left w-[150px]";

type Props = {
    daysBetween: DayItem[],
    data: EmployeeInReport[],
    setData: SetStateFn<EmployeeInReport[]>,
};

const TimesheetTable = ({data, setData, daysBetween}: Props) => {
    return (
        <div
            className="w-full overflow-x-auto rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm"
        >
            <table className="w-max min-w-full text-sm text-gray-900 dark:text-slate-100 border-collapse">
                <thead className="bg-white dark:bg-slate-800 text-sm font-semibold">
                <tr>
                    <th className={titleColClassName}>
                        <FormattedMessage id={"employees"}/>
                    </th>

                    <th
                        className={twJoin(
                            colClassName,
                            "border-b border-r",
                        )}
                    >
                        <FormattedMessage id={"total"}/>
                    </th>

                    {daysBetween.map(d =>
                        <th
                            className={twJoin(
                                colClassName,
                                "border-b",
                            )}
                            key={d.formattedDay}
                        >
                            {d.formattedDay}
                        </th>
                    )}
                </tr>
                </thead>
                <tbody>
                {data.map((employee: EmployeeInReport) =>
                    <EmployeeRow
                        key={employee.id}
                        employee={employee}
                        daysBetween={daysBetween}
                        setData={setData}
                    />
                )}
                </tbody>
            </table>
        </div>
    );
};

export default TimesheetTable;